import * as React from 'react';
import './index.css';
import * as ReactDOM from 'react-dom/client';
import { createHashRouter, RouterProvider, useNavigate } from 'react-router-dom';
import App from './App';
import Layout from './layouts/Layout';
import AuthLayout from './auth/Layout';
import Dashboard from './pages/Dashboard';
import Posts from './pages/Posts';
import Snapshots from './pages/Snapshots';
import AddPost from './pages/AddPost';
import Orders from './pages/Orders';
import reportWebVitals from './reportWebVitals';
import GoogleOAuth from './auth/GoogleOAuth';

const router = createHashRouter([
  {
    Component: App,
    children: [
      {
        path: '/',
        Component: Layout,
        children: [
          {
            path: '/',
            Component: Dashboard,
          },
          {
            path: '/posts',
            Component: Posts,
          },
          {
            path: '/update-post',
            Component: AddPost,
          },
          {
            path: '/snapshots',
            Component: Snapshots,
          },
          {
            path: '/orders',
            Component: Orders,
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    Component: AuthLayout,
    children: [
      {
        path: 'login',
        Component: GoogleOAuth,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();